import reqProvider from '../coreRequests';
import { SEARCH_API } from '../urlPaths';
import { getToken } from 'config/lib';
import { SagaIterator } from 'redux-saga';
import { AxiosRequestHeaders } from 'axios';
import { call } from 'redux-saga/effects';
import { iElectronicsMpnResponse } from 'store/types/electronicsMpnSearch';

export function* postElectronicsMpnSearch(manufacturerPartNumber: string): SagaIterator{
  const token = getToken();
  const requestPath = `${SEARCH_API}/search/electronics/mpn`;
  const headers: AxiosRequestHeaders = {
    'Content-Type': 'application/json', Authorization: `Bearer ${token}`
  };

  const response = yield call(reqProvider.postReq, requestPath, headers, { manufacturerPartNumber })

  // ✅ Manual check for API errors (e.g. status !== 200)
  if (!response || response.status !== 200) {
    const error: any = new Error('MPN Search failed')
    error.response = { status: response?.status || 500 }
    throw error
  }

  return response.data as iElectronicsMpnResponse
}

export default {
    postElectronicsMpnSearch,
}